import useToastedMutation from '../../../../ReactQuery/useToastedMutation';
import { post } from '../../../../redux/api';

/**
 * Initiate email MFA setup - creates method and sends verification code
 */
export default function useInitEmailSetup() {
  return useToastedMutation({
    mutationFn: async () => {
      return post<never, void>('/api/auth/mfa/email/init', undefined as never);
    },
    successToastMessage: 'Verification code sent to your email',
    errorToastMessage: 'Failed to initiate email MFA setup',
  });
}
